<template>
    <textarea class="appearance-none bg-white border leading-normal outline-none py-2 px-3 rounded w-full" @input="$emit('input', $event.target.value)" :value="value"></textarea>
</template>

<script>
    export default {
        props: {
            value: {
                required: true,
            }
        }
    };
</script>
